/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setMegaMenuToggle.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * @name setMegaMenuToggle
 * @description メガメニューの開閉をする
 * @param {Object} megaMenu メガメニューの要素
 * @param {class} openMegaMenu メガメニューの開くクラス
 * @param {const} closeMegaMenu メガメニューの閉じる関数
 */
function setMegaMenuToggle() {
    const main = document.querySelector('main');
    const megaMenu = document.querySelectorAll('.globalNav .nav__menu-item.--has-child');
    if (megaMenu.length === 0) return;

    class openMegaMenu {
        constructor(el) {
            this.el = el;
            this.el.addEventListener('mouseenter', () => {
                this.el.classList.add('--show');
                megaMenu.forEach((el) => el !== this.el && el.classList.remove('--show'));
            });
        }
    }

    const closeMegaMenu = () => megaMenu.forEach((el) => el.classList.remove('--show'));

    megaMenu.forEach((el) => new openMegaMenu(el));
    window.addEventListener('scroll', () => closeMegaMenu());
    main.addEventListener('mouseenter', () => closeMegaMenu());
}

export { setMegaMenuToggle }